module.exports = __webpack_public_path__ + "/images/logo-app-appstore.fr-FR.7d41b3a.svg";